// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HdC0B","comment":"styles_comment__3mFqY"};